import type { CreatorRow, DirectionName } from "odyssey-shared";
import { say } from "../../words.ts";

/**
 * The Look panel's wording that takes a count or a facing. The words are the language files' (`look.*` in
 * `odyssey-lang`); the counts beside a row's name follow the design card's "Tone 4 of 10".
 */

/**
 * The count beside a row's name: which of its tones or colours is chosen.
 *
 * @param row The row.
 * @param place The chosen one's place, from 1.
 * @param count How many the row has.
 * @returns The count, "Tone 4 of 10".
 */
export function lookCount(row: CreatorRow, place: number, count: number): string {
  return row === "skin" ? say("look.tone", { place: String(place), count: String(count) }) : say("look.colour", { place: String(place), count: String(count) });
}

/**
 * A swatch's accessible name.
 *
 * @param row The row's name.
 * @param place The swatch's place, from 1.
 * @param count How many the row has.
 * @returns The name, "Hair colour 2 of 7".
 */
export function lookSwatch(row: string, place: number, count: number): string {
  return say("look.swatch", { row, place: String(place), count: String(count) });
}

/**
 * The figure's accessible name.
 *
 * @param facing The way the figure faces.
 * @returns The name, with the facing's word as it reads inside the sentence.
 */
export function lookFigure(facing: DirectionName): string {
  return say("look.figure", { facing: { k: `look.figureFacings.${facing}` } });
}
